import { CircularProgress, Page } from 'ui/components'

import {
  AdverseMediaTable,
  AlertsSideBar,
  AnnualReviewsTable,
  ApplicationsTable,
  BSATable,
  CRBMonitor,
  CTRsTable,
  DocumentsDue,
  HRRTable,
  MonthlyAnalyticsTable,
  QuarterlyAnalyticsTable,
  SARsListTable,
  UploadsPendingApproval
} from './components'
import { AlertsContextProvider, useAlertsContext } from './context'

const AlertsContent = () => {
  const { data } = useAlertsContext()

  const showCRB =
    data?.showCRBLicenseDisconnectedCount ||
    data?.showCRBLicenseEntityMismatchCount ||
    data?.showCRBLicenseStatusMismatchCount ||
    0

  if (!data) {
    return <CircularProgress centered />
  }

  return (
    <>
      <AlertsSideBar data={data} />
      <DocumentsDue />
      {data.uploads !== undefined && <UploadsPendingApproval />}
      {data.applications !== undefined && <ApplicationsTable />}
      {data.showCTRs !== undefined && <CTRsTable />}
      {data.showBsaBatches !== undefined && <BSATable />}
      {data.showSARs !== undefined && <SARsListTable />}
      {data.showMonthlyAnalytics !== undefined && <MonthlyAnalyticsTable />}
      {data.showQuarterlyAnalytics !== undefined && <QuarterlyAnalyticsTable />}
      {data.showHighRiskReview !== undefined && <HRRTable />}
      {data.annualReviews !== undefined && <AnnualReviewsTable />}
      {data.showAdverseMedia !== undefined && <AdverseMediaTable />}
      {showCRB > 0 && <CRBMonitor />}
    </>
  )
}

const AlertsPage = () => {
  return (
    <Page title="Alerts">
      <AlertsContextProvider>
        <AlertsContent />
      </AlertsContextProvider>
    </Page>
  )
}

export default AlertsPage
